import React from "react";
import { useAuth } from "./useAuth";
import { Navigate, Outlet, useLocation } from "react-router-dom";
const DEBUG_PREFIX = "[PROTECTED-ROUTE]";
export default function ProtectedRoute({ children, fallback }) {
    const { isAuthenticated, inProgress, account } = useAuth();
    const location = useLocation();
    // During MSAL startup/redirect processing, wait instead of redirecting
    if (!isAuthenticated && inProgress && inProgress !== "none") {
        return (React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "center", minHeight: "200px" } },
            React.createElement("span", null, "Loading\u2026")));
    }
    if (!isAuthenticated) {
        const redirectTarget = location.pathname + location.search + location.hash;
        console.warn(DEBUG_PREFIX, "Not authenticated — saving target and redirecting to /login", {
            savedTarget: redirectTarget,
        });
        if (typeof sessionStorage !== "undefined") {
            try {
                sessionStorage.setItem("postLoginRedirect", redirectTarget);
            }
            catch (_a) { }
        }
        return React.createElement(Navigate, { to: "/login", replace: true });
    }
    // Support both wrapper usage (<ProtectedRoute>{children}</ProtectedRoute>)
    // and route-guard usage (<Route element={<ProtectedRoute/>}> ... )
    if (children)
        return React.createElement(React.Fragment, null, children);
    return React.createElement(Outlet, null);
}
